module.exports = __webpack_public_path__ + "img/sp_article_1.e6fc7e37.jpg";